import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.bundle.min.js' 
import AOS from 'aos'
import 'aos/dist/aos.css' 


import VueHtmlToPaper from 'vue-html-to-paper';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
const options = {
  name: '_balnk',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    // 'https://cdn.rtlcss.com/bootstrap/v4.5.3/css/bootstrap.min.css',
    // 'https://unpkg.com/kidlat-css/css/kidlat.css'
    // '/assets/css/print.css',
    '/css/adminlte.rtl.css',
    '/assets/css/rtl.css',
    // '/assets/css/c_print.css',
    'https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap',
    // '/assets/vendor/css/core.css'

  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: false, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}

Vue.use(VueHtmlToPaper, options);

Vue.config.productionTip = false
Vue.use({
  install() {
    AOS.init({
      duration: 800, // مدة الحركة
      easing: 'ease-in-out', // نوع الحركة
      once: true, // تشغيل الحركة مرة واحدة فقط
    });
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
